export const LEFT_SIDEBAR_TOGGLE = 'left_sidebar_toggle';
export const LEFT_SIDEBAR_SET = 'left_sidebar_set';
// export const RIGHT_SIDEBAR_TOGGLE = "right_sidebar_toggle";
